"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = exports.lowcode = void 0;
require("babel-polyfill");
var _zqylModuleFunction = _interopRequireDefault(require("zqyl-module-function"));
var _components = _interopRequireDefault(require("./components"));
var _main = _interopRequireDefault(require("./lib/main.js"));
var _index = _interopRequireDefault(require("./index.vue"));
var _request = _interopRequireDefault(require("./lib/request.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var utils = _main["default"];
exports.utils = utils;
var lowcode = {
  inject: function inject(Vue, app) {
    this.loadConfig(Vue);
    Vue.use(_components["default"]);
    Vue.prototype.$APP = app;
    Vue.prototype.$lowcode = _main["default"];
    Vue.prototype.$function = _zqylModuleFunction["default"];
  },
  loadConfig: function loadConfig(Vue) {
    _request["default"].get(_main["default"].baseUrl() + "/project.config.json").then(function (res) {
      Vue.prototype.$config = res.data;
    })["catch"](function (error) {
      console.error(error);
    });
  },
  addRouter: function addRouter(router) {
    router.addRoutes([{
      path: '/lc/:pageId',
      name: 'lowCodePreview',
      component: _index["default"]
    }, {
      path: '/lc/:pageId/:branchId',
      name: 'lowCodePreview',
      component: _index["default"]
    }]);
  }
};
exports.lowcode = lowcode;